// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2XsEe","amount":"Amount_amount__1z3Q3","tip":"Amount_tip__2iS9x","tipHeader":"Amount_tipHeader__18UPj","tipsWrap":"Amount_tipsWrap__Xv8aW"};